import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((res: HttpErrorResponse) => {
      if (res.status === 500) {
        toast.error('Ocurrió un error en el servidor');
      } else if (res.error.message) {
        toast.error(res.error.message);
      } else {
        toast.error('Error desconocido');
      }

      return throwError(() => res);
    })
  );
};
